import { createSelector } from '@reduxjs/toolkit';
import { observeStore } from '@ff-os/pdp-shared-redux/observeStore';
import { selectAllGroups } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { selectAllPhotos } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpState, PhotoPrintsPdpStore } from '@ff-scene-plugins/photo-prints-redux/store';

export const addDesignChangeListener = (store: PhotoPrintsPdpStore, callback: () => void) => {
    observeStore(store, selectPhotosByGroup, callback);
};

const selectPhotosByGroup = createSelector([
    (state: PhotoPrintsPdpState) => selectAllGroups(state),
    (state: PhotoPrintsPdpState) => selectAllPhotos(state)
], (groups, photos) => {
    return groups.map(g => ({
        id: g.id,
        variantId: g.variantId,
        photos: photos.filter(p => p.groupId === g.id)
    }));
});